import { InsightChurnRisk, InsightHealthBand, InsightTrend } from 'lib-trend-core';

/** The system badge variant of each fixed value (RF-20); the word is always shown beside the colour (RNF-10). */
const BADGE_TONES: Record<string, string> = {
  positive: 'is-ok',
  neutral: 'is-neutral',
  negative: 'is-err',
  low: 'is-ok',
  medium: 'is-warn',
  high: 'is-err',
  healthy: 'is-ok',
  stableWithFriction: 'is-warn',
  atRisk: 'is-err',
  progress: 'is-ok',
  attention: 'is-warn',
};

const HEALTH_BARS: Record<InsightHealthBand, string> = {
  healthy: 'bg-success',
  stableWithFriction: 'bg-warning',
  atRisk: 'bg-danger',
};

const TREND_ARROWS: Record<InsightTrend, string> = {
  improving: '↗',
  stable: '→',
  worsening: '↘',
};

const RISK_KEYS: Record<InsightChurnRisk, string> = {
  low: 'riskLow',
  medium: 'riskMedium',
  high: 'riskHigh',
};

export function badgeTone(value: string): string {
  return BADGE_TONES[value] ?? 'is-neutral';
}

export function healthBarClass(band: InsightHealthBand): string {
  return HEALTH_BARS[band] ?? 'bg-secondary';
}

export function trendArrow(trend: InsightTrend): string {
  return TREND_ARROWS[trend] ?? '';
}

/** The i18n key of a churn-risk level under a prefix: the summary's badge, or the accordion's lowercase meta. */
export function riskKey(prefix: string, level: InsightChurnRisk): string {
  return prefix + (RISK_KEYS[level] ?? 'riskLow');
}
